// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jcuM","inner":"Footer_inner__m_gty"};